import Accordion from 'devextreme-react/accordion';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CheckBox from 'devextreme-react/check-box';

export default function VesselAccordion({
  searchedVessels,
  onVesselSelectionChange,
}: {
  searchedVessels: any[];
  onVesselSelectionChange?: (selectedVesselImos: string[]) => void;
}) {
  const { t } = useTranslation();
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const [selectedVesselImos, setSelectedVesselImos] = useState<string[]>([]);

  const accordionItems = useMemo(() => {
    return [
      {
        title: t('labels.vessels'),
        visible: true,
      },
    ];
  }, [t]);

  useEffect(() => {
    setSelectedItems(accordionItems);
  }, [accordionItems]);

  useEffect(() => {
    const newSelectedVesselImos = searchedVessels
      .filter((vessel) => vessel.selected)
      .map((vessel) => vessel.imo);
    setSelectedVesselImos(newSelectedVesselImos);
  }, [searchedVessels]);

  const handleVesselCheckboxChange = (imo: string, checked: boolean) => {
    const newSelectedVesselImos = checked
      ? [...selectedVesselImos, imo]
      : selectedVesselImos.filter((id) => id !== imo);
    setSelectedVesselImos(newSelectedVesselImos);
    if (onVesselSelectionChange) {
      onVesselSelectionChange(newSelectedVesselImos);
    }
  };

  const handleSelectAll = () => {
    const allImos = searchedVessels.map((vessel) => vessel.imo);
    setSelectedVesselImos(allImos);
    if (onVesselSelectionChange) {
      onVesselSelectionChange(allImos);
    }
  };

  const handleUnselectAll = () => {
    setSelectedVesselImos([]);
    if (onVesselSelectionChange) {
      onVesselSelectionChange([]);
    }
  };

  const accordionItemRender = (e: any) => {
    if (e.title === t('labels.vessels')) {
      return (
        <div className="m-c-checkbox-dark">
          {searchedVessels.length > 0 &&
            searchedVessels.map((vessel) => (
              <div
                key={vessel.imo}
                className="m-l-grid-top-header-list-column p-2"
              >
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                  <CheckBox
                    key={`vessel-checkbox-${
                      vessel.imo
                    }-${selectedVesselImos.includes(vessel.imo)}`}
                    elementAttr={{ 'data-testid': `vessel-${vessel.imo}` }}
                    value={selectedVesselImos.includes(vessel.imo)}
                    onValueChanged={(e) =>
                      handleVesselCheckboxChange(vessel.imo, e.value)
                    }
                  />
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="red"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ transform: 'rotate(90deg)' }}
                  >
                    <path
                      opacity="0.15"
                      d="M12 3L19 20L12 17L5 20L12 3Z"
                      fill="red"
                    />
                    <path
                      d="M19 20L12 3L5 20L12 17L19 20Z"
                      stroke="red"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span>{vessel.vesselName}</span>
                </div>
              </div>
            ))}
          {searchedVessels.length > 0 && (
            <div className="checkbox-modes">
              <a className="m-l-page-id-text" onClick={handleSelectAll}>
                {t('buttons.selectAll')}
              </a>
              <a className="m-l-page-id-text" onClick={handleUnselectAll}>
                {t('buttons.unselectAll')}
              </a>
            </div>
          )}
        </div>
      );
    }
    return null;
  };

  const selectionChanged = (e: any) => {
    let newItems: any = [...selectedItems];
    e.removedItems.forEach((item: any) => {
      const index = newItems.indexOf(item);
      if (index >= 0) {
        newItems.splice(index, 1);
      }
    });
    if (e.addedItems.length) {
      newItems = [...newItems, ...e.addedItems];
    }
    setSelectedItems(newItems);
  };

  return (
    <div className="m-l-accordion-panel-body-block">
      <div className="m-l-accordion__main-section u-p0">
        <div className="m-c-accordion">
          <Accordion
            collapsible={true}
            multiple={false}
            items={accordionItems}
            itemRender={accordionItemRender}
            selectedItems={selectedItems}
            onSelectionChanged={selectionChanged}
          />
        </div>
      </div>
    </div>
  );
}
